module.exports = __webpack_public_path__ + "static/media/kgp-slide-4.1bd53cd7.jpg";